//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PreviousDeferredReportWarning',
  props: {
    objectNumber: {
      type: String,
      default: ''
    },
    to: {
      type: [String, Object],
      default: null
    },
    onLinkClick: {
      type: Function,
      default: null
    }
  },
  methods: {
    handleLinkClick: function () {
      if (this.onLinkClick) {
        this.onLinkClick()
      }
    }
  }
}
